import { Dayjs } from "dayjs";
import {
  DateTimeInput,
  DropDownLookUpInput,
  FormFields,
  FormSection,
  NumberInput,
  OptionSetInput,
  PhoneInput,
  TextInput,
} from "../../../../types";
import { publicSpaceReservationDisplayNames } from "../../displayNames";
import { OptionSetNumber } from "../../../common/types";
import { incidentOptionSetsChoices } from "../../optionSetChoices";

export type EditDemandPublicSpaceReservationFields = {
  vdl_courriel: TextInput;
  vdl_debutdelareservation: DateTimeInput;
  vdl_findelareservation: DateTimeInput;
  vdl_ndetelephoneprincipal: PhoneInput;
  vdl_titre: OptionSetInput;
  vdl_prenom: TextInput;
  vdl_nom: TextInput;
  vdl_nombredeparticipants: NumberInput;
  vdl_nomdusiteareserver: DropDownLookUpInput;
  vdl_sousplateau: DropDownLookUpInput;
};

const editDemandPublicSpaceReservationFields: EditDemandPublicSpaceReservationFields =
  {
    vdl_nomdusiteareserver: {
      type: "lookup",
      error: "",
      value: null,
      choices: [],
      required: true,
      label: publicSpaceReservationDisplayNames._vdl_nomdusiteareserver_value,
    },
    vdl_sousplateau: {
      type: "lookup",
      error: "",
      value: null,
      choices: [],
      required: true,
      label: publicSpaceReservationDisplayNames._vdl_sousplateau_value,
    },
    vdl_debutdelareservation: {
      type: "datetime",
      error: "",
      value: null,
      required: true,
      disablePast: true,
      label: publicSpaceReservationDisplayNames.vdl_debutdelareservation,
      onChangeEvent: (fields) =>
        onDateDebutChange(fields as EditDemandPublicSpaceReservationFields),
    },
    vdl_findelareservation: {
      type: "datetime",
      error: "",
      value: null,
      required: true,
      disablePast: true,
      label: publicSpaceReservationDisplayNames.vdl_findelareservation,
      minDate: (fields: FormFields) =>
        (fields.vdl_debutdelareservation.value as Dayjs)
          ? (fields.vdl_debutdelareservation.value as Dayjs)
          : undefined,
    },
    vdl_nombredeparticipants: {
      type: "number",
      error: "",
      value: null,
      required: true,
      label: publicSpaceReservationDisplayNames.vdl_nombredeparticipants,
    },
    vdl_nom: {
      type: "text",
      error: "",
      value: "",
      required: true,
      label: publicSpaceReservationDisplayNames.vdl_nom,
    },
    vdl_courriel: {
      type: "text",
      error: "",
      value: "",
      required: false,
      label: publicSpaceReservationDisplayNames.vdl_courriel,
    },
    vdl_ndetelephoneprincipal: {
      type: "phone",
      error: "",
      value: "",
      required: true,
      label: publicSpaceReservationDisplayNames.vdl_ndetelephoneprincipal,
    },
    vdl_prenom: {
      type: "text",
      error: "",
      value: "",
      required: true,
      label: publicSpaceReservationDisplayNames.vdl_prenom,
    },
    vdl_titre: {
      type: "options",
      error: "",
      value: null,
      choices: incidentOptionSetsChoices.vdl_titre,
      fillLine: true,
      required: true,
      label: publicSpaceReservationDisplayNames.vdl_titre,
    },
  };

  
function onDateDebutChange(
  fields: EditDemandPublicSpaceReservationFields
): Partial<EditDemandPublicSpaceReservationFields> | undefined {
  try {
    return {
      vdl_findelareservation: {
        ...fields.vdl_findelareservation,
        value:
          fields.vdl_findelareservation.value &&
          fields.vdl_findelareservation.value.isBefore(
            fields.vdl_debutdelareservation.value as Dayjs
          )
            ? null
            : fields.vdl_findelareservation.value,
      },
    };
  } catch (e) {
    return undefined;
  }
}


const editDemandRervationInfoSection: FormSection<EditDemandPublicSpaceReservationFields> =
  {
    fields: [
      "vdl_nomdusiteareserver",
      "vdl_sousplateau",
      "vdl_debutdelareservation",
      "vdl_findelareservation",
      "vdl_nombredeparticipants",
    ],
    title: "Informations réservation",
  };
const editDemandRervationContactSection: FormSection<EditDemandPublicSpaceReservationFields> =
  {
    fields: [
      "vdl_titre",
      "vdl_prenom",
      "vdl_nom",
      "vdl_courriel",
      "vdl_ndetelephoneprincipal",
    ],
    title: "Personne à contacter",
  };

const editDemandRervationSections: FormSection<EditDemandPublicSpaceReservationFields>[] =
  [editDemandRervationInfoSection, editDemandRervationContactSection];

export { editDemandPublicSpaceReservationFields, editDemandRervationSections };
